// extracted by mini-css-extract-plugin
export default {"container":"commonTable_container__LaNXv","title":"commonTable_title__+FRwn"};